import { environment } from 'src/environments/environment';

export interface APIUrl {
  name : string;
  url  : string;
}

export const EnvironmentsAPIUrl : APIUrl = {
  name: 'Por defecto', 
  url: environment.apiUrl
}